
export const REDIRECTION_TIMEOUT = 15000;
export const TIMER_EXPIRED_TIMEOUT = 120000;
